<template>
  <div class="product-section">
    <h2 style="text-align: center; margin-top: 2em;">
      {{ $t('product_features_title')}}
    </h2>
    <div>
      <div class="feature left">
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_feature_title_1') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_feature_text_1_1">
                <b>{{ $t('at_one_place') }}</b>
                <b>{{ $t('at_a_glance') }}</b>
              </i18n>
              <p>{{ $t('product_feature_text_1_2') }}</p>
            </div>
          </div>
        </div>
        <div class="image">
          <img :src="`/static/img/feature_01_${$i18n.locale}.png`" />
        </div>
      </div>
      <div class="feature right">
        <div class="image">
          <img :src="`/static/img/feature_02_${$i18n.locale}.png`" />
        </div>
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_feature_title_2') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_feature_text_2_1">
                <b>{{ $t('freight_intelligence') }}</b>
                <b>{{ $t('libra') }}</b>
                <b>{{ $t('vforwarding') }}</b>
                <b>{{ $t('automatically') }}</b>
                <b>{{ $t('facilitate_tracking') }}</b>
              </i18n>
              <i18n tag="p" path="product_feature_text_2_2">
                <b>{{ $t('erp') }}</b>
              </i18n>
            </div>
          </div>
        </div>
      </div>
      <div class="feature left">
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_feature_title_3') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_feature_text_3_1">
                <b>{{ $t('google_maps') }}</b>
              </i18n>
              <i18n tag="p" path="product_feature_text_3_2">
                <b>{{ $t('easy_tracking') }}</b>
              </i18n>
              <p>{{ $t('product_feature_text_3_3') }}</p>
            </div>
          </div>
        </div>
        <div class="image">
          <img src="/static/img/feature_03.png" />
        </div>
      </div>
      <div class="feature right">
        <div class="image">
          <img src="/static/img/feature_04.png" />
        </div>
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_feature_title_4') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_feature_text_4_1">
                <b>{{ $t('complete_route') }}</b>
              </i18n>
              <i18n tag="p" path="product_feature_text_4_2">
                <b>{{ $t('reliables') }}</b>
                <b>{{ $t('actionable') }}</b>
              </i18n>
            </div>
          </div>
        </div>
      </div>
      <div class="feature left">
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_feature_title_5') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_feature_text_5_1">
                <b>{{ $t('record_of_events') }}</b>
              </i18n>
              <i18n tag="p" path="product_feature_text_5_2">
                <b>{{ $t('visibility') }}</b>
                <b>{{ $t('transparency') }}</b>
                <b>{{ $t('confidence') }}</b>
                <b>{{ $t('clarity') }}</b>
              </i18n>
            </div>
          </div>
        </div>
        <div class="image">
          <img src="/static/img/feature_05.png" />
        </div>
      </div>
      <div class="feature right">
        <div class="image">
          <img src="/static/img/feature_06.png" />
        </div>
        <div class="text">
          <div class="text-wrapper">
            <h3>{{ $t('product_feature_title_6') }}</h3>
            <div class="description">
              <i18n tag="p" path="product_feature_text_6_1">
                <b>{{ $t('optimize') }}</b>
                <b>{{ $t('pay_based') }}</b>
              </i18n>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'product-info',
  components: { },
  props: []
}
</script>
<style lang="scss">

.product-section {
  margin: 2em 0;
}
.feature {
  margin: 0 auto;
  padding: 1.5em 5%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .text{
    flex:5;
    max-width: 100%;
    box-sizing: border-box;
    padding: 2em 0;
    .text-wrapper {
      height: 100%;
      margin: auto;
      max-width: 100%;
      min-width: 20em;
      width: 35em;
      h3 {
        margin-bottom: 1em;
      }
    }
  }
  .image {
    flex:7;
    margin: 2em 0;
    min-width: 20em;
    max-width: 100%;
    width: 25em;
  }
  &.right {
    text-align: right;
    flex-wrap: wrap-reverse;
    .image {
      margin-right: 10%;
    }
  }
  &.left {
    .image {
      margin-left: 10%;
    }
  }
}

@media screen and (max-width: 950px) {
  .feature {
    .text {
      .text-wrapper {
        width: auto;
        min-width:10em;
      }
    }
    &.right {
      flex-direction: column-reverse;
      text-align: center;
      .image {
        margin-right: 0;
        width:40em;
      }
    }
    &.left {
      flex-direction: column;
      text-align: center;
      .image {
        margin-left: 0;
        width:42em;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/ProductFeatures.vue